export const CustomerVariableModel = {
    customerVariableId: '',
    attributeId: '',
    customerId: '',
    byDefault: '',
    hidden: false,
    hint: '',
    mandatory: false,
    mask: '',
    nickname: '',
    order: 0,
    readonly: false,
    validateText: ''
}

export const CustomerVariableHeaders = [
    {
        text: "Действия",
        value: "actions",
        sortable: false
    },
    {
        text: 'Название',
        value: 'nickname'
    },
    {
        text: 'Описание',
        value: 'hint'
    },
    {
        text: 'Порядок следования',
        value: 'order'
    },
    {
        text: 'Удалён',
        value: 'deletedHuman'
    },
    ]
